var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recipe-toggle-disabled"},[_c('a',{on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.data.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }